<template>
    <section>
        <form name="mailTo">
            <div class="container">
                <h3>문의사항</h3>
                <p>문의사항은 이메일로 보내주세요.</p>
                <div class="form-group">
                    <input type="text" placeholder="제목" class="form-control" v-model="title" >
                </div>
                <div class="form-group" style="margin-top: 10px;">
                    <textarea class="form-control" placeholder="문의 내용을 입력해 주세요." rows="11" v-model="contents"></textarea>
                </div>
                <div class="text-right" style="margin-top: 10px; margin-bottom: 20px;">
                    <a :href="mailtoHref()" class="btn btn-primary">전송</a>
                </div>
            </div>
        </form>
    </section>
</template>

<script>

    export default {
        name: 'Questions',

        data() {
            return {
                adminEmail: "info@ekara.org",
                title: "",
                contents: "",
                email: "",
            };
        },
        methods: {
            mailtoHref(){
                return 'mailto:' + this.adminEmail + '?subject=' + this.title + "&body=" + this.contents;
            },
        },
    }
</script>
<style scoped>

</style>